import {FC, ReactNode} from "react";
import "./DetailsColumnHeader.scss";

export interface DetailsColumnHeaderProps {
  id?: string;
  label: string;
  aside?: ReactNode;
}

export const DetailsColumnHeader: FC<DetailsColumnHeaderProps> = ({
  id,
  label,
  aside
}) => {
  const headerId = id ? `details-column-header-${id}` : "details-column-header";
  return (
    <header
      id={headerId}
      data-testid={headerId}
      className={"details-column-header"}>
      <hgroup className={"details-column-header-group"}>
        <h3>{label}</h3>
        {aside && (
          <aside className={"details-column-header-callout"}>{aside}</aside>
        )}
      </hgroup>
    </header>
  );
};
